import React, {useEffect, useState} from 'react';
import {compose} from "redux";
import {connect} from "react-redux";
import Blog from "./Blog";
import {addBlogTh, deleteBlogTh, getBlogsTh, updateBlogTh} from "../../redux/blogReducer";

let mapStateToProps =(state)=>({
    blogs:state.blogPage.blogs,
    totalPages:state.blogPage.totalPages,
    totalElements:state.blogPage.totalElements,
    size:state.blogPage.size,
})

const BlogContainer = ({getBlogsTh,blogs,...props}) => {
    let [blogList,setBlogList]=useState(blogs)
    debugger
    useEffect(()=>{
        getBlogsTh(0,10)
        // getGroupsTh(0,100)
    },[])  
    useEffect(()=>{
        setBlogList(blogs)
    },[blogs])
    
    return (
        <div className="content-wrapper">
            {blogList.length>0 && <Blog
                blogs={blogs}
                {...props}
            />}
        </div>
    );
};

export default compose(
    connect(mapStateToProps,{
        getBlogsTh,
        addBlogTh,
        updateBlogTh,
        deleteBlogTh,
    })
)(BlogContainer);
